import { render, staticRenderFns } from "./PerformancePersonEdit.vue?vue&type=template&id=7e1f2d79&scoped=true&"
import script from "./PerformancePersonEdit.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1f2d79",
  null
  
)

export default component.exports